var React = require('react');

function XmarkInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.16145 11.3293C0.845049 11.6457 0.829982 12.2107 1.16899 12.5422C1.50046 12.8736 2.06547 12.8661 2.38188 12.5497L6.99237 7.93167L11.6104 12.5497C11.9343 12.8736 12.4918 12.8736 12.8233 12.5422C13.1472 12.2032 13.1548 11.6532 12.8233 11.3293L8.21279 6.71124L12.8233 2.10075C13.1548 1.77681 13.1548 1.21933 12.8233 0.88786C12.4843 0.563921 11.9343 0.556387 11.6104 0.880327L6.99237 5.49835L2.38188 0.880327C2.06547 0.563921 1.49293 0.548854 1.16899 0.88786C0.837515 1.21933 0.845049 1.78434 1.16145 2.10075L5.77948 6.71124L1.16145 11.3293Z","fill":"currentColor"}));
}

XmarkInline.defaultProps = {"width":"14","height":"13","viewBox":"0 0 14 13","fill":"none"};

module.exports = XmarkInline;

XmarkInline.default = XmarkInline;
